import styled from 'styled-components'
import { Colors } from "../utils/colors";

export const Background = styled.div`
    background-color: ${Colors.BackgroundGray};
    height: ${window.innerHeight - 61}px;
    max-height: ${window.innerHeight - 61}px;
`